import { getMessages } from '../../../../../../store/constants';

export const PRICING_POLL_DONE_TEXT = getMessages().getText('pricing-poll.done');
export const PRICING_POLL_DONE_LINK_TEXT = getMessages().getText('pricing-poll.link');
export const PRICING_POLL_DONE_LINK = 'https://calendly.com/kanbanchi/streamline-your-workflow?month={date}';

export const CLASS_PRICING_POLL = 'pricing-poll-done';
